import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import Product from "../../../master/item/Product";

const InventoryTransaction = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/operationalwise");
  };
  const [subTypeId, setSubTypeId] = useState(0);
  const [subTypeData, setSubTypeData] = useState([]);

  const [warehouseId, setWarehouseId] = useState(0);
  const [warehouseData, setWarehouseData] = useState([]);

  const [productId, setProductId] = useState(0);
  const [productData, setProductData] = useState([]);
  const [filterdProduct, setFilterdProduct] = useState([]);

  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getprocurementData } = useHttp();

  const fillData = (productId, warehouseId) => {
    setData([])
    var urlfilter = "";

    if (productId > 0) {
      urlfilter = `&productId=${productId}`;
    }

    if (warehouseId > 0) {
      urlfilter = urlfilter + `&warehouseId=${warehouseId}`;
    }

    var url = `/api/fillInventoryTransactionReport/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter}`;

    getprocurementData(
      {
        url: url,
      },
      (res) => {

        var records=res.sort((a, b) => {
          return new Date(b.transactionDate) - new Date(a.transactionDate); // descending
        })
        setData(records);
      }
    );
  };

  useEffect(() => {
    fillData(0,0);
  }, [getprocurementData]);

  const { sendRequest: getSubType } = useHttp();

  const subTypeDetails = () => {
    getSubType(
      {
        url: `/api/fillProductSubListForAutoComplete/?orgId=${localStorage.getItem(
          "orgId"
        )} `,
      },
      (data) => {
        setSubTypeData(data);
      }
    );
  };

  useEffect(() => {
    subTypeDetails();
  }, [getSubType]);

  const { sendRequest: getproduct } = useHttp();

  const productDetails = () => {
    getproduct(
      {
        url: `/api/fillProductListForAutoComplete/?orgId=${localStorage.getItem(
          "orgId"
        )} `,
      },
      (data) => {
        
        setProductData(data);
      } 
    );
  };

  useEffect(() => {
    productDetails();
  }, [getproduct]);

  useEffect(() => {
    const filtered =
      productData &&
      productData.filter(
        (product) => product.productSubTypeId === parseInt(subTypeId)
      );
    setFilterdProduct(filtered);
  }, [subTypeId]);

  const { sendRequest: getwarehouse } = useHttp();
  useEffect(() => {
    getwarehouse(
      {
        // url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}`,
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (data) => {
        setWarehouseData(data);
        console.log(data);
      }
    );
  }, [getwarehouse]);

  const fieldsToExport = [
    "warehouseName",
    "docNo",
    "productType",
    "productSubType",
    "productName",
    "operation",
    "inOut",
    "transactionDate",
    "employeeName",
    "quantity",
    "unit",
    "productCost",
    "currenecy"
  ];

  const customHeaders = [
    "Warehouse Name",
    "Doc No",
    "Product Type Name",
    "Product Sub Type Name",
    "Product Name",
    "Operation",
    "IN/OUT",
    "Date",
    "Employee Name",
    "Quantity",
    "Unit",
    "Product Cost",
    "Currency",
  ];

  const handleExportExcel = () => {
    const filename = "InventoryTransactionReport.xlsx";
    
    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Inventory Transaction Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <hr />

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Warehouse Name</label>
                  <select
                    id="warehouseId"
                    className="form-control"
                    ref={(el) => (frmRef.current["warehouseId"] = el)}
                    value={warehouseId}
                    required
                    onChange={(e) => {
                      setWarehouseId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {warehouseData &&
                      warehouseData.map((x) => (
                        <option key={x.id} value={x.id}>
                          {x.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"Product Sub Type"}>
                    {"Product Sub Type"}
                  </label>
                  <select
                    id="subType"
                    className="form-control"
                    value={subTypeId}
                    required
                    onChange={(e) => {
                      setSubTypeId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {subTypeData &&
                      subTypeData.map((x) => (
                        <option
                          key={x.productSubTypeId}
                          value={x.productSubTypeId}
                        >
                          {x.productSubTypeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"product_name"}>{"Product Name"}</label>
                  <select
                    id="product_name"
                    className="form-control"
                    value={productId}
                    required
                    onChange={(e) => {
                      setProductId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {filterdProduct &&
                      filterdProduct.map((x) => (
                        <option key={x.productId} value={x.productId}>
                          {x.productName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillData(productId, warehouseId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center table-responsive">
                      <thead>
                        <tr className="table-header">
                          <th> Warehouse Name</th>

                          <th> Product Type Name </th>
                          <th> Product Sub Type Name </th>
                          <th> Product Name </th>
                          <th>Operation</th>

                          <th> IN/OUT</th>
                          <th> Date</th>

                          <th> Employee Name</th>
                          <th> Quantity</th>
                          <th> Unit</th>

                          <th> Product Cost</th>
                          <th>Currency</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.warehouseName}</td>
                                <td>{itm.productType}</td>
                                <td>{itm.productSubType}</td>
                                <td>{itm.productName}</td>

                                <td>{itm.operation}</td>
                                <td>{itm.inOut}</td>
                                <td>{itm.transactionDate}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.quantity}</td>
                                <td>{itm.unit}</td>
                                <td>
                                  {parseFloat(itm.productCost).toFixed(2)}
                                </td>
                                <td>{itm.currenecy}</td>
                             
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default InventoryTransaction;
